import { useMemo } from 'react';
import { useOwnersContext } from '../context/OwnersContext';
export default function useUnifiedEventApprovers(event) {
  const owners = useOwnersContext();
  return useMemo(() => {
    const approverIds = event.properties.hs_steps_approvers_owners_ids_list.value.split(';');
    return approverIds.map(approverId => owners.find(owner => String(owner.ownerId) === approverId)).filter(Boolean);
  }, [owners, event]);
}